import * as React from 'react'

import { BlockedPeriodPolicyFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'

import Item from './Item'

interface ListProps {
  data: Array<BlockedPeriodPolicyFragment>
  totalCount: number | null | undefined
}

const List: React.FC<ListProps> = ({ data, totalCount }) => {
  const blockedPeriodPolicies = data

  if (!totalCount) return <></>

  return (
    <BoxList>
      {blockedPeriodPolicies.map((policy: BlockedPeriodPolicyFragment) => (
        <Item policy={policy} key={policy.id} policies={blockedPeriodPolicies} />
      ))}
    </BoxList>
  )
}

export default observer(List)
